<template>
  <v-dialog
    v-model="isDialogOpenLocale"
    persistent
    :max-width="maxWidth"
  >
    <v-card class="pa-sm-8 pa-2">
      <btn-close-dialog :handle-click="closeDialog" />

      <v-card-title class="d-flex justify-center text-h5 pt-0">
        <span>{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text class="mt-5">
        <slot> </slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'

export default {
  components: {
    BtnCloseDialog,
  },

  props: {
    isDialogOpen: {
      type: Boolean,
      required: true,
    },
    maxWidth: {
      type: String,
      default: null,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
    dialogTitle: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const isDialogOpenLocale = ref(false)

    watchEffect(() => {
      isDialogOpenLocale.value = props.isDialogOpen
    })

    return {
      isDialogOpenLocale,
    }
  },
}
</script>
